<div class="container" role="main">
    <div class="HmsContainer">
        <div class="row">
            <div class="row HmsInsideContainer">
                <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"></div>
                <div class="col-xs-12 col-sm-12 col-md-11 col-lg-11">
                    <div class="col-xs-12 col-sm-12 col-md-11 col-md-12 contaner-padding-left">
                        <button type="button" class="greyBtn" (click)="back()" style="font-weight : bold;">Go to
                            Previous
                            Section</button>
                        <button type="button" class="greyBtn ml-5" *ngIf="isInstruction" (click)="openInstruction()"
                            style="font-weight : bold;">Instructions</button>
                        <button type="button" class="orangeBtn ml-5" *ngIf="isFormsValid" (click)="userDetailsSubmit()"
                            [ngStyle]="{'background-color': primaryColor}">Proceed
                            to Next Section</button>
                    </div>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"></div>
                <div class="col-xs-12 col-sm-12 col-md-11 col-lg-11">
                    <div class="col-md-12 contaner-padding-left">
                        <p role="heading" aria-level="1">Please enter details regarding this referral</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row HmsInsideContainer">
            <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"></div>
            <div class="col-xs-12 col-sm-12 col-md-11 col-lg-11">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <form class="userForm" [formGroup]="witnessFormPart1">
                            <div class="col-md-10" *ngIf="isformloaded">
                                <app-json-form [controlsData]="witnessFormDataPart1.controls"
                                    [formData]="witnessFormPart1" [textAreaCol]="30" [textAreaRows]="9"
                                    [textAreaCounterPositionClass]="'pull-left'"
                                    (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                            </div>
                        </form>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <form class="userForm" [formGroup]="witnessFormPart2">
                            <div class="col-md-10" *ngIf="isformloaded">
                                <app-json-form [controlsData]="witnessFormDataPart2.controls"
                                    [formData]="witnessFormPart2" (valueChangeEvent)="valueChangeEvent($event)"
                                    [customClass]="'width50p'"></app-json-form>
                            </div>
                        </form>
                        <form class="userForm" [formGroup]="witnessFormPart3">
                            <div class="col-md-10" *ngIf="isformloaded">
                                <app-json-form [controlsData]="witnessFormDataPart3.controls"
                                    [formData]="witnessFormPart3" (valueChangeEvent)="valueChangeEvent($event)"
                                    [customClass]="'width60p'"></app-json-form>
                            </div>
                        </form>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <form class="userForm" [formGroup]="witnessFormPart4">
                            <div class="col-md-10" *ngIf="isformloaded">
                                <app-json-form [controlsData]="witnessFormDataPart4.controls"
                                    [formData]="witnessFormPart4" [textAreaCol]="30" [textAreaRows]="20"
                                    (valueChangeEvent)="valueChangeEvent($event)"></app-json-form>
                            </div>
                            <button type="button" class="orangeBtn" *ngIf="isFormsValid" (click)="userDetailsSubmit()"
                                [ngStyle]="{'background-color': primaryColor}">Proceed
                                to Next Section</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>